import { axios } from "@cores/axiosWrapper";

export const getMySharedAssetsAPI = (apiEndpoint, params, signal) => {
    return axios.get(`${apiEndpoint}/my-shared-assets`, {
        params,
        signal,
    });
};

export const getMySharingAssetsAPI = (apiEndpoint, params, signal) => {
    return axios.get(`${apiEndpoint}/my-sharing-assets`, {
        params,
        signal,
    });
};

export const listSharedAssetProjectsAPI = (apiEndpoint, params, signal) => {
    return axios.get(`${apiEndpoint}/my-shared-assets/projects`, {
        params,
        signal,
    });
};

export const listSharingAssetProjectsAPI = (apiEndpoint, params, signal) => {
    return axios.get(`${apiEndpoint}/my-sharing-assets/projects`, {
        params,
        signal,
    });
};

export const getSharedUsersOfAssetAPI = (apiEndpoint, stageId, projectId, assetId, params, signal) => {
    const headers = {
        stageId,
        projectId,
    };
    return axios.get(`${apiEndpoint}/assets/${assetId}/shares`, {
        params,
        headers,
        signal,
    });
};

export const deleteSharedUsersOfAssetAPI = (apiEndpoint, stageId, projectId, assetId, shareId, customErrorMessage) => {
    const headers = {
        stageId,
        projectId,
    };
    return axios.delete(`${apiEndpoint}/assets/${assetId}/shares/${shareId}`, {
        headers,
        customErrorMessage,
    });
};

export const changeSharedUsersOfAssetAPI = (
    endpoint,
    stageId,
    projectId,
    assetId,
    shareId,
    data,
    customErrorMessage,
) => {
    const headers = {
        stageId,
        projectId,
    };
    return axios.patch(`${endpoint}/assets/${assetId}/shares/${shareId}`, data, {
        headers,
        customErrorMessage,
    });
};

export const addSharedUsersOfAssetAPI = (endpoint, stageId, projectId, assetId, data, customErrorMessage) => {
    const headers = {
        stageId,
        projectId,
    };
    return axios.post(`${endpoint}/assets/${assetId}/shares`, data, {
        headers,
        customErrorMessage,
    });
};
